import Box from 'ui/src/components/Box'
import IconButton from 'ui/src/components/IconButton'
import { useNavigate } from 'react-router-dom'
import ConciergeIcon from 'ui/src/assets/images/SignupFlow/concierge.svg?react'
import { Tooltip } from 'ui/src/components/Tooltip'

const Concierge = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Tooltip title="Concierge">
        <IconButton
          onClick={() => {
            navigate('/concierge')
          }}
          sx={{ width: '100%', height: '100%', cursor: 'pointer' }}
        >
          <ConciergeIcon
            data-cy="concierge"
            style={{
              height: '1.25rem',
              width: '1.25rem',
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default Concierge
